var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "page-title " }, [
      _vm._v(" " + _vm._s(_vm.$t("menu.user_list")) + " "),
    ]),
    _c(
      "div",
      { staticClass: "system-user-list page-container" },
      [
        _c(
          "div",
          { staticClass: "filter-container" },
          [
            _c("div", { staticClass: "filter-container-tag" }, [
              _vm._v(" " + _vm._s(_vm.$t("components.activity")) + " "),
            ]),
            _c("el-input", {
              staticClass: "search-frame",
              attrs: { placeholder: "Username", clearable: "" },
              model: {
                value: _vm.search.username,
                callback: function ($$v) {
                  _vm.$set(_vm.search, "username", $$v)
                },
                expression: "search.username",
              },
            }),
            _c(
              "el-button",
              {
                staticClass: "search-btn",
                attrs: { type: "primary", icon: "el-icon-search" },
                on: { click: _vm.handleFilter },
              },
              [_vm._v(_vm._s(_vm.$t("components.search")))]
            ),
            _c(
              "el-button",
              {
                staticClass: "filter-btn-add mb10 ",
                attrs: { type: "primary" },
                on: { click: _vm.showAddUserModal },
              },
              [
                _c("i", {
                  staticClass: "el-icon-plus",
                  staticStyle: { "font-weight": "600" },
                }),
                _vm._v(" " + _vm._s(_vm.$t("system.add_user"))),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "tableContainer" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  stripe: "",
                  fit: "",
                  "highlight-current-row": "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: _vm.$t("system.username"), align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._v(" " + _vm._s(scope.row.username) + " ")]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("system.login_email"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._v(" " + _vm._s(scope.row.email) + " ")]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("system.authorized_status"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 2,
                              "active-color": "#3855F1",
                              "inactive-color": "#98A1B4",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeAuthorizedStatus(scope.row)
                              },
                            },
                            model: {
                              value: scope.row.on_off,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "on_off", $$v)
                              },
                              expression: "scope.row.on_off",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _vm.$store.getters.isPii ||
                _vm.$store.getters.isEz ||
                _vm.$store.getters.isAruxpay
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("system.notification_config"),
                        align: "center",
                        "min-width": "125",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "success", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showNotificationConfigModal(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("system.notification_config")
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2918419775
                      ),
                    })
                  : _vm._e(),
                _c("el-table-column", {
                  attrs: { label: _vm.$t("system.role"), align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              staticStyle: { margin: "5px" },
                              attrs: { type: "info", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.showModifyAuthModal(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("system.assign_role")))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("components.create_time"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(" " + _vm._s(scope.row.create_time) + " "),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                !_vm.listLoading
                  ? _c("paginator", {
                      attrs: { "list-query": _vm.listQuery },
                      on: { "paginator-change": _vm.confirm },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c("add-user-modal"),
        _c("modify-pwd-modal"),
        _c("assign-role-modal", {
          ref: "assignRoleRef",
          attrs: { "menu-list": _vm.menu_list },
          on: { updateRoleList: _vm.handleFilter },
        }),
        _c("NotificationConfigModalGlobal"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }